module.exports = __webpack_public_path__ + "media/22.8ed7ddf7.mp3";